import React, { memo } from 'react';
import { useTranslation } from '@blocs.i18n';
import DropdownWithChildren, {
  DropdownTogglerTypeEnum,
  SelectionsResultTypeEnum,
} from '@minecraft.dropdown-with-children';
import { SelectOption } from '@minecraft.typings';

interface PrimarySelectProps {
  name: string;
  options: SelectOption[];
  handleChange?: (value: SelectOption) => void;
  toggleLabel?: string;
  className?: string;
}

const PrimarySelect = ({
  name,
  options,
  handleChange,
  toggleLabel,
  className,
  ...rest
}: PrimarySelectProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <DropdownWithChildren
      className={className}
      isMultipleSelect={false}
      isCollapsable={false}
      withFormik
      withSearch
      withSelectionsResult
      placeholder={t('common:form.placeholder.select')}
      selectionsResultType={SelectionsResultTypeEnum.pill}
      dropdownTogglerType={DropdownTogglerTypeEnum.input}
      name={name}
      options={options}
      onOptionsChange={handleChange}
      dataTestId="working-location"
      qaId="working-location"
      toggleLabel={toggleLabel}
      {...rest}
    />
  );
};

export default memo(PrimarySelect);
